import { yupResolver } from "@hookform/resolvers/yup";
import { useSnackbar } from "notistack";
import React from "react";
import { Resolver, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import { formatDate } from "../../../shared/functions/formatDate";
import { handleError } from "../../../shared/functions/handleError";
import { IInvoice } from "../../../shared/interfaces/invoice/IInvoice";
import { AdminInvoiceService } from "../service";
import { invoiceSchema } from "./InvoiceCreate";
import InvoiceForm from "./InvoiceForm";

const InvoiceUpdate = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const { id } = useParams();

  const { handleSubmit, control, watch, setValue } = useForm<IInvoice>({
    resolver: yupResolver(invoiceSchema) as unknown as Resolver<IInvoice>,
    defaultValues: async () => {
      const response = await AdminInvoiceService.getSingle(Number(id));
      const data = {
        ...response,
        client: undefined,
        project: undefined,
        clientId: response?.client?.id,
      } as IInvoice;
      return data;
    },
  });

  const submitHandler = (formData: IInvoice) => {
    AdminInvoiceService.update(
      {
        ...formData,
        dueDate: formatDate(formData.dueDate, "yyyy-MM-DD"),
      },
      Number(id),
    )
      .then((response) => {
        if (response) {
          navigate(-1);
          enqueueSnackbar(
            t("toasts.successfullyUpdated", { title: formData?.invoiceNumber }),
            {
              variant: "success",
            },
          );
        }
      })
      .catch(handleError);
  };
  return (
    <form onSubmit={handleSubmit(submitHandler)}>
      <InvoiceForm
        control={control}
        watch={watch}
        setValue={setValue}
        isUpdate
      />
    </form>
  );
};

export default InvoiceUpdate;
